import utils from '@/utils'

export default {
  state: {
    eventId: utils.storage.get('eventId'),
    eventInfo: utils.storage.get('event')
  },
  mutations: {
    updateEventId (state, eventId) {
      state.eventId = eventId
    },
    updateEventInfo (state, info) {
      state.eventInfo = info
    }
  },
  actions: {
    updateEventId ({commit}, eventId) {
      utils.storage.set('eventId', eventId)
      commit('updateEventId', eventId)
    },
    updateEventInfo ({commit}, info) {
      utils.storage.set('eventInfo', info)
      commit('updateEventInfo', info)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/event.js